import { fromEvent } from "rxjs";

export const onPageComplete$ = fromEvent(window, 'load');
export const bodyClick$ = fromEvent(document.body, 'click');